import React from 'react';
import BookForm from '../components/BookForm';
import Navbar from '../components/Navbar';

const EditPage = () => {
  return (
    <>
      <Navbar />
      <BookForm />
    </>
  );
};

export default EditPage;
